import CategoryList from '@/components/category/CategoryList'

const CategoriesPage = () => {
  return <CategoryList />
}

export default CategoriesPage
